import Vue from 'vue'
import {jsPlumb} from 'jsplumb'
import i18n from '../../../../translations/i18n'

/**
 * jsPlumb Toolkit Vue 2 integration.
 */

let connectProperties = {
  // detachable: false,
  connectorStyle: {stroke: '#5c96bc', strokeWidth: 3, outlineStroke: 'transparent', outlineWidth: 5},
  endpointStyle:{ fillStyle:'blue', outlineColor:'black', outlineWidth:1 },
  paintStyle: {stroke: '#5c96bc', strokeWidth: 3, outlineStroke: 'transparent', outlineWidth: 5},

  connector: getUrlParam('connector', '') || 'Straight',
  // // connector: [ 'Flowchart', { stub: [40, 60], gap: 10, cornerRadius: 5, alwaysRespectStubs: true } ],
  // Connector: [ 'Bezier', { curviness: 50 } ],

  anchors: [
    ['Perimeter', {shape: 'Rectangle'}],
    ['Perimeter', {shape: 'Rectangle'}]
  ]
  // anchor: ['AutoDefault', 'AutoDefault']
}
connectProperties.ConnectorStyle = connectProperties.connectorStyle
connectProperties.PaintStyle = connectProperties.paintStyle
connectProperties.Connector = connectProperties.connector
connectProperties.Anchors = connectProperties.anchors

export var jsPlumbToolkitVue2 = {
    addToolkit: function (view) {
        let params = {}
        params.DragOptions = { cursor: 'pointer', zIndex: 2000 }
        params.container = 'canvas'
        params.ConnectionOverlays = [
          [ 'Arrow', {
            location: 1,
            id: 'arrow',
            length: 14,
            foldback: 0.8
          } ]
        ]
        let toolkit = jsPlumb.getInstance(params)
        toolkit.allNodes = {}

        function generateId() {
            let id = 'jsPlumb_3_' + Math.floor(Math.random() * 1000)
            if (document.getElementById(id)) {
              return generateId()
            } else {
              return id
            }
        }

        toolkit.addNode = function (data, scenarioId, availableSmsGateways) {
            let Cls = Vue.extend(view.nodeComponent)
            data.scenarioId = scenarioId
            data.data.id = data.data.id || generateId()
            data.availableSmsGateways = availableSmsGateways
            // data.client = client
            let component = new Cls({
              data: { obj: data }
            })
            return toolkit.addComponent(component, true, false)
        }
        toolkit.addRedirectNode = function (data) {
          let Cls = Vue.extend(view.nodeRedirectComponent)
          data.view.id = data.view.id || generateId()
          let component = new Cls({
            data: { obj: data }
          })
          return toolkit.addComponent(component, false, true)
        }
        toolkit.addSmsNode = function(data) {
          let Cls = Vue.extend(view.nodeSmsComponent)
          data.view.id = data.view.id || generateId()
          let component = new Cls({
            data: { obj: data }
          })
          component.isSms = true
          return toolkit.addComponent(component, false, false)
        }
        toolkit.addHttpRequestNode = function(data) {
          let Cls = Vue.extend(view.nodeHttpRequestComponent)
          data.view.id = data.view.id || generateId()
          let component = new Cls({
            data: { obj: data }
          })
          component.isHttpRequest = true
          return toolkit.addComponent(component, false, false)
        }
        toolkit.addComponent = function (component, isAnswer, isRedirect) {
          component.$mount() // could pass some toolkit stuff here
          component.toolkit = toolkit

          document.getElementById('canvas').appendChild(component.$el)
          toolkit.draggable(component.$el, {scroll:false})

          connectProperties.filter = '.add i.connect'
          toolkit.makeSource(component.$el, connectProperties)
          toolkit.makeTarget(component.$el, {
            anchor: [ 'Perimeter', { shape:'Rectangle' } ]
          })

          component.isAnswer = isAnswer
          component.isRedirect = isRedirect
          toolkit.allNodes[component.$el.id] = component
          return component
        }

        toolkit.addCustomConnection = function(sourceComponent, targetComponent) {
          let sourceEl
          let targetEl
          if (typeof sourceComponent === 'string' || sourceComponent instanceof String) {
            sourceEl = document.getElementById(sourceComponent)
          } else {
            sourceEl = sourceComponent.$el
          }
          if (typeof targetComponent === 'string' || targetComponent instanceof String) {
            targetEl = document.getElementById(targetComponent)
          } else {
            targetEl = targetComponent.$el
          }

          let sourceConnections = toolkit.getConnections({source:sourceEl.id})
          if (sourceConnections && sourceConnections.length) {
            for (let i = 0; i < sourceConnections.length; i++) {
              if (sourceConnections[i].targetId === targetEl.id) {
                return
              }
            }
          }

          toolkit.connect({source:sourceEl, target:targetEl}, connectProperties)
        }

        toolkit.customRemoveNode = function(nodeId) {
          this.remove(nodeId)
          this.allNodes[nodeId] = null
        }

        toolkit.getFirstTarget = function(node) {
          let connections = this.getConnections({source:node.$el.id})
          if (!connections || !connections.length) {
            return null
          } else {
            return this.allNodes[connections[0].targetId]
          }
        }

        toolkit.getAllTargets = function(node) {
          let connections = this.getConnections({source:node.$el.id})
          if (!connections || !connections.length) {
            return null
          } else {
            let targets = []
            for (let i = 0; i < connections.length; i++) {
              targets.push(this.allNodes[connections[i].targetId])
            }
            return targets
          }
        }

        toolkit.getRedirectData = function (nodeId) {
          let node = this.allNodes[nodeId]
          if (node) {
            let target = this.getFirstTarget(node)
            if (target && target.isRedirect) {
              return {
                sip: target.$el.querySelector('.sipNumber').value,
                w: target.$el.offsetWidth,
                h: target.$el.offsetHeight,
                top: target.$el.offsetTop,
                left: target.$el.offsetLeft,
                id: target.$el.id
              }
            }
          }
          return null
        }

        toolkit.getRedirectUrl = function (nodeId) {
          let data = this.getRedirectData(nodeId)
          if (data) {
            return data.sip
          }
        }

        toolkit.getSmsData = function (nodeId) {
          let node = this.allNodes[nodeId]
          if (node) {
            let targets = this.getAllTargets(node)
            if (targets) {
              for (let i = 0; i < targets.length; i++) {
                let target = targets[i]
                  if (target.isSms && target.$el.querySelector('.smsGateway') && target.$el.querySelector('.smsText')) {
                    return {
                      data: {
                        gateway: target.$el.querySelector('.smsGateway').value,
                        sender: target.$el.querySelector('.sender').value,
                        text: target.$el.querySelector('.smsText').value
                      },
                      view: {
                        w: target.$el.offsetWidth,
                        h: target.$el.offsetHeight,
                        top: target.$el.offsetTop,
                        left: target.$el.offsetLeft,
                        id: target.$el.id
                      }
                    }
                  }
              }
            }
          }
          return null
        }

        toolkit.getHttpRequestData = function (nodeId) {
          function getKeValList(target, type) {
            let result = {}
            let objects = target.$el.querySelectorAll('.' + type)
            for (let i = 0; i < objects.length; i++) {
              let key = objects[i].querySelector('.key').value
              let value = objects[i].querySelector('.value').value
              if (key) {
                result[key] = value
              }
            }
            return result
          }

          let node = this.allNodes[nodeId]
          if (node) {
            let targets = this.getAllTargets(node)
            if (targets) {
              for (let i = 0; i < targets.length; i++) {
                let target = targets[i]
                if (target.isHttpRequest) {
                  return {
                    data: {
                      method: target.$el.querySelector('.method').value,
                      url: target.$el.querySelector('.url').value,
                      body: target.$el.querySelector('.body').value,
                      headers: getKeValList(target, 'header'),
                      params: getKeValList(target, 'param')
                    },
                    view: {
                      w: target.$el.offsetWidth,
                      h: target.$el.offsetHeight,
                      top: target.$el.offsetTop,
                      left: target.$el.offsetLeft,
                      id: target.$el.id
                    }
                  }
                }
              }
            }
          }
        }
        return toolkit
    }
}

export var BaseNodeComponent = {
    methods: {
        getToolkit: function () { return this.toolkit },
        deleteNode() {
          let toolkit = this.getToolkit()
          toolkit.remove(this.$el.id)
        }
    },
    i18n: i18n
}


Vue.component('jsplumb-toolkit', {
    props: ['view', 'scenarioId', 'client', 'availableSmsGateways'],
    template: '<div style="width:100%;height:100%"></div>',
    mounted: function () {
      this.toolkit = jsPlumbToolkitVue2.addToolkit(this._props.view)
      if (this.startCallBacks) {
        for (let i = 0; i < this.startCallBacks.length; i++) {
          this.startCallBacks[i]()
        }
        this.startCallBacks = []
      }
    },
    data() {
      return {
        toolkit: null,
        startCallBacks: []
      }
    },
    methods: {
      // getToolkit: function () {
      //   return this.toolkit
      // },
      drawScenario(scenarioData) {
        let scenarioVisual = scenarioData.visual
        if (scenarioVisual && scenarioVisual.hideArrows) {
          document.getElementById('canvas').classList.add('hidden_arrows')
        }
        if (scenarioVisual && scenarioVisual.compactWindows) {
          document.getElementById('canvas').classList.add('compact_windows')
        }
        let that = this
        function draw() {
          console.log('draw scenario')
          let nodes = document.querySelectorAll('#Konstruktor .flowchart-object')
          for (let i = nodes.length - 1; i >= 0; i--) {
            that.toolkit.customRemoveNode(nodes[i].id)
          }

          for (let i = 0; i < scenarioData.states.length; i++) {
            let state = scenarioData.states[i]
            let node = that.toolkit.addNode(state, that.scenarioId, that._props.availableSmsGateways)

            if (state.redirectSipNumber) {
              node.addRedirect(state.redirectSipNumber, state.redirectView)
            }
            if (state.smsData) {
              node.addSMS(state.smsData.data, state.smsData.view, that._props.availableSmsGateways)
            }
            if (state.httpRequestData) {
              node.addHttpRequest(state.httpRequestData.data, state.httpRequestData.view)
            }
          }

          if (scenarioData.connections && scenarioData.connections.length) {
            for (let i = 0; i < scenarioData.connections.length; i++) {
              let connection = scenarioData.connections[i]
              that.toolkit.addCustomConnection(connection.sourceId, connection.targetId)
            }
          }
        }

        if (this.toolkit) {
          draw()
        } else {
          this.startCallBacks.push(draw)
        }
      },
      getAllConnections() {
        return this.toolkit.getAllConnections()
      },
      getRedirectData(nodeId) {
        return this.toolkit.getRedirectData(nodeId)
      },
      getSmsData(nodeId) {
        return this.toolkit.getSmsData(nodeId)
      },
      getHttpRequestData(nodeId) {
        return this.toolkit.getHttpRequestData(nodeId)
      }
    }
})

function getUrlVars() {
  var vars = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
    vars[key] = value
  })
  return vars
}

function getUrlParam(parameter, defaultvalue) {
  var urlparameter = defaultvalue
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter]
  }
  return urlparameter
}





// WEBPACK FOOTER //
// ./client/views/scenarios/konstruktor/jsplumb-extends/jsplumb-vue.js